/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/order-items';

export const OrderItemApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderItems: async (id: string, options: any) => {
    let url = `${pathname}/order/${id}/entity`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findForReceivedMoney: async (options: any) => {
    let url = `${pathname}/find-for-received-money`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findForDebtMoney: async (options: any) => {
    let url = `${pathname}/find-for-debt-money`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findOrderItemsWithOrder: async (options: any) => {
    let url = `${pathname}/find-with-order`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findAllOrderItemsWithOrder: async (options: any) => {
    let url = `${pathname}/find-all-with-order`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findOrderItemsForForward: async (options: any) => {
    let url = `${pathname}/find-for-forward`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findToExport: async (option: FindOptions) => {
    let url = `${pathname}/find-to-export`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findConfirmAmountDelivered: async (orderID: string, options: any) => {
    let url = `${pathname}/order/${orderID}/entity/confirm-amount-delivered`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findConfirmAmountReceived: async (orderID: string, options: any) => {
    let url = `${pathname}/order/${orderID}/entity/confirm-amount-received`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  findConfirmAmountReceivedOfCustomer: async (
    orderID: string,
    options: any
  ) => {
    let url = `${pathname}/order/${orderID}/entity/confirm-amount-received-of-customer`;
    const query = serialize(options);
    url += query;

    const response = await entityService.get(url);

    return response;
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePreProcessing: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/pre-processing`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSupplierQuantity: async (
    id: string,
    options: any,
    body: UpdateOrderItemSupplierQuantityBody
  ) => {
    let url = `${pathname}/update-supplier-quantity/${id}`;

    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateOrderItemNote: async (id: string, body: UpdateOrderItemNoteBody) => {
    const url = `${pathname}/update-note/${id}`;
    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOrderItemsFromChainSuppliers: async (
    option: FindOrderItemsFromChainSuppliersQuery
  ) => {
    let url = `${pathname}/find-order-items-from-chain-suppliers`;
    const { startedAt, finishedAt, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, { startedAt, finishedAt });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateAmountDelivered: async (params: UpdateAmountDeliveredBody) => {
    const { id, body } = params;
    const url = `${pathname}/${id}/entity/update-amount-delivered`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateAmountDeliveredReceived: async (
    params: UpdateAmountDeliveredReceivedBody
  ) => {
    const { id, body } = params;
    const url = `${pathname}/${id}/entity/update-amount-delivered-received`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateAmountReceived: async (params: UpdateAmountReceivedBody) => {
    const { id, body } = params;
    const url = `${pathname}/${id}/entity/update-amount-received`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  convertQuantityToStandardUnitByEntity: async (orderID: string) => {
    const url = `${pathname}/order/${orderID}/entity/convert-to-standard-unit`;
    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

interface UpdateOrderItemNoteBody {
  supplierNote?: string;
  customerNote?: string;
}

export interface FindOrderItemsFromChainSuppliersQuery {
  productID?: string;
  entityProductID?: string;
  collaboratorProductID?: string;
  orderStatus?: number[];
  type?: number;
  page: number;
  take: number;
  order: any;
  customerName?: string;
  startedAt?: string;
  finishedAt?: string;
}

export interface UpdateOrderItemSupplierQuantityBody {
  supplierQuantity?: number;
  supplierQuantityInProductStandardUnit?: number;
}

export interface UpdateAmountDeliveredBody {
  id: string;
  body: {
    orderItems: Array<{
      id: string;
      supplierDeliveredQuantity: number;
    }>;
  };
}

export interface UpdateAmountDeliveredReceivedBody {
  id: string;
  body: {
    orderItems: Array<{
      id: string;
      supplierDeliveredQuantity: number;
      customerReceivedQuantity: number;
    }>;
  };
}

export interface UpdateAmountReceivedBody {
  id: string;
  body: {
    orderItems: Array<{
      id: string;
      customerReceivedQuantity: number;
    }>;
  };
}

export interface UpdateAmountDeliveryReceivedDeliveryType {
  id: string;
  value: number;
  orderItem: any;
  type: 'DELIVERY' | 'RECEIVED';
}
